import moment from "moment";
import { hasPermission, UPDATE_DROPBOX_FILE } from "./constants";

const MONITORED_PATH_FOR_HISTORY_2 = "/woning media nederland - afgeronde opdrachten 2024"

/**
 * Build customer data JSON string based on project configuration and form values
 * @returns {string} customer data in JSON format
 */
export const buildCustomerData = (newProjectConfig, companyId, customerDataFormValues, customerDataNotes) => {
  const filteredConfig = newProjectConfig.filter(c => companyId === companyId);

  if (filteredConfig?.length === 0) {
    return "";
  }
  let customerData = [];
  filteredConfig.forEach(item => {
    customerData.push({
      key: item.key,
      value: customerDataFormValues[item.label] || "-",
      note: customerDataNotes[item.label] || "",
      label: item.label
    });
  });

  return JSON.stringify(customerData);
}


export const buildSummary = (newProjectConfig, companyId, formValues, notes) => {
  const filteredConfig = newProjectConfig.filter(c => c.companyId === companyId);

  if (filteredConfig?.length === 0) {
    return null;
  }
  // Build HTML layout
  let html = `
      <div style="display: flex; gap: 40px; max-width: 600px;">
        <div style="flex: 1; white-space: normal">
          <strong style="padding-left: 20px; ">IMPORTANT INFO</strong>
          <ul style="padding-left: 20px; ">
    `;

  filteredConfig.forEach(item => {
    const value = formValues[item.label] || "-";
    html += `<li>${item.label}: ${value}</li>`;
  });

  html += `
          </ul>
        </div>
        <div style="flex: 1; white-space: normal">
          <strong>Notes:</strong>
          <ul style="list-style-type: none; padding-left: 0">
    `;

  filteredConfig.forEach(item => {
    const note = notes[item.label] || "";
    html += `<li>${note}</li>`;
  });

  html += `
          </ul>
        </div>
      </div>
    `;

  return html;
};

export const highlightText = (text) => {
        // regex to catch "xx m2 GO" and "+xx m2"
        const parts = text?.split(/( \+?\d+\s*m2\s*GO| \+?\d+\s*m2)/g);

        return (
            <span style={{ color: "black" }}>
                {parts?.map((part, i) =>
                    /(m2 GO|m2)/.test(part) && /\d/.test(part) ? (
                        <span key={i} style={{ color: "red" }}>
                            {part}
                        </span>
                    ) : (
                        part
                    )
                )}
            </span>
        );
    }


export const isWrongFileName = (file) => {
  if (file.filePath.includes(MONITORED_PATH_FOR_HISTORY_2)) return false;

  if (file.isRenamed || file.name.endsWith(".e57") || file.isDeleted) {
    return false;
  }

  const name = file.name;
  const allowedPattern = /[^A-Za-z0-9 _+\-]/; // matches any char NOT in allowed set (letters, digits, space, _, +, -)

  // Allow .e57 and .b2g extensions
  if (name.toLowerCase().endsWith(".e57") || name.toLowerCase().endsWith(".b2g")) {
    // check only the base name (without extension)
    const baseName = name.substring(0, name.lastIndexOf("."));
    return allowedPattern.test(baseName);
  }

  // normal check for other files
  return allowedPattern.test(name);
};

export const getColorHistory = (file) => {
  if (file.filePath.includes(MONITORED_PATH_FOR_HISTORY_2)) return file.isDeleted ? 'red' : 'blue';
  return isWrongFileName(file) || file.isDeleted ? 'red' : 'black'
}

export const showEditHistory = (file, permissions) => {
  if (file.filePath.includes(MONITORED_PATH_FOR_HISTORY_2)) return false;

  return file.name.includes(".b2g") && !file.isRenamed && !file.isDeleted
    && hasPermission(permissions, UPDATE_DROPBOX_FILE)
}